import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Users, CalendarDays, CreditCard, ArrowRight } from 'lucide-react';

const QUICK_ACTIONS = [
  { to: '/leads', icon: FileText, label: 'Manage Leads' },
  { to: '/appointments', icon: CalendarDays, label: 'Calendar' },
  { to: '/members', icon: Users, label: 'View Members' },
  { to: '/billing', icon: CreditCard, label: 'Billing' },
];

export function QuickActions() {
  return (
    <div className="border border-slate-200 rounded-sm bg-white">
      <div className="p-4 border-b border-slate-200">
        <h2 className="font-heading font-semibold text-slate-900 text-sm">Quick Actions</h2>
      </div>
      <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
        {QUICK_ACTIONS.map(a => (
          <Link key={a.to} to={a.to} className="flex items-center justify-between p-3 border border-slate-200 rounded-sm hover:border-[#0047AB] hover:bg-blue-50/50 transition-all duration-200">
            <div className="flex items-center gap-3">
              <a.icon className="w-4 h-4 text-[#0047AB]" />
              <span className="text-sm font-medium text-slate-700">{a.label}</span>
            </div>
            <ArrowRight className="w-4 h-4 text-slate-400" />
          </Link>
        ))}
      </div>
    </div>
  );
}
